import Image from 'next/image';
import IconDarkJetblack from './logo_dark_jetblack.svg?url';
import IconWhite from './logo_white.svg?url';
import type { SvgImageProps } from '../types';

export const UnextLogoAndTypeDarkJetblackImage: React.FC<SvgImageProps> = ({
  alt,
  ...props
}) => <Image src={IconDarkJetblack} alt={alt} {...props} />;

export const UnextLogoAndTypeWhiteImage: React.FC<SvgImageProps> = ({
  alt,
  ...props
}) => <Image src={IconWhite} alt={alt} {...props} />;
